import { useState } from "react";

import { useSelector } from "react-redux";

import { Button, Card, CardContent, CardHeader, Typography } from "@mui/material";

import { LegacyFeedbackDialog } from "views/Home/LegacyFeedbackDialog";

export const V9_ORANGE = "#E37439";
export const V9_ORANGE_HOVER = "#c9612e";
export const V9_ORANGE_DISABLED = "#e0a070";
const LEGACY_CUTOFF_ID = 77220;
const LEGACY_START = new Date("2026-04-21T00:00:00");
const LEGACY_END = new Date("2026-05-16T00:00:00");
const forceShowLegacy =
  new URLSearchParams(window.location.search).get("showLegacy") === "true";

export function LegacyFeedbackCard() {
  const {
    company: { id },
  } = useSelector((state) => state.userCompanySettings);

  const now = new Date();
  const show =
    forceShowLegacy ||
    (id < LEGACY_CUTOFF_ID && now >= LEGACY_START && now < LEGACY_END);

  const [dialogOpen, setDialogOpen] = useState(false);

  if (!show) {
    return null;
  }

  return (
    <>
      <Card
        variant="outlined"
        sx={{
          maxWidth: 600,
          mt: "1rem",
          borderLeft: `4px solid ${V9_ORANGE}`,
        }}
      >
        <CardHeader title="Need to return to the previous version?" />
        <CardContent>
          <Typography sx={{ mb: 2 }}>
            We understand the transition takes time. If you need to access the
            legacy version, we'd appreciate a moment of your feedback first, so
            we can make V9 work for you.
          </Typography>
          <Button
            onClick={() => setDialogOpen(true)}
            sx={{
              backgroundColor: V9_ORANGE,
              color: "white",
              "&:hover": { backgroundColor: V9_ORANGE_HOVER },
            }}
          >
            Take me to the previous version
          </Button>
        </CardContent>
      </Card>
      <LegacyFeedbackDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
    </>
  );
}
